import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { BehaviorSubject, combineLatest, Observable, ReplaySubject, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";
import { compare } from "src/app/globals";
import { EMailAudit } from "../../../classes";
import { MailService } from "../../../services/mail.service";

@Injectable()
export class MailInboxComponentService {

    convertedBody: string = null;

    account$: Observable<'assignment' | 'incident'> = this._route.params.pipe(map((params: HttpParams) => params['account'] === 'incident' ? 'incident' : 'assignment'));

    private _mails = new ReplaySubject<EMailAudit[]>(1);
    mails$ = this._mails.asObservable();

    private _currentMailId = new ReplaySubject<string>(1);
    currentMailId$ = this._currentMailId.asObservable();
    currentMail$ = combineLatest([this.mails$, this.currentMailId$]).pipe(map(([mails, messageId]) => mails.find(x => x.messageId === messageId)));

    private _mailsLoading = new BehaviorSubject(false);
    mailsLoading$ = this._mailsLoading.asObservable();

    private _subscriptions: Subscription[] = [];

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _mailService: MailService
    ) {
        this.setUp();
    }

    checkForNewMails() {
        this.clearCurrentMail();
        this.account$.pipe(take(1)).subscribe((account) => this.refresh(account));
    }

    clearCurrentMail() {
        this.convertedBody = null;
        this._router.navigate([], {
            relativeTo: this._route,
            queryParamsHandling: 'merge',
            queryParams: { 'mail-id': null }
        });
        this._currentMailId.next(null);
    }

    dispose() {
        for (let sub of this._subscriptions) sub.unsubscribe();
        this._subscriptions = [];
    }

    refresh(account: 'incident' | 'assignment') {
        this._mailsLoading.next(true);
        this._mailService.loadUnseenMailsFromMailInbox(account).subscribe({
            next: (mails) => this._mails.next(mails.sort((a, b) => compare(a.received, b.received, false))),
            complete: () => this._mailsLoading.next(false)
        });
    }

    setUp() {
        this._subscriptions.push(
            this._route.queryParams.subscribe((params: Params) => {
                if (params['mail-id']) this._currentMailId.next(params['mail-id']);
            })
        );
    }

}